import { useCallback, useEffect, useRef, useState } from 'react';

export const useSizeGuide = ({ sizeGuide, ref = null, styles, isMobile }) => {
  const radioGroupRef = useRef(null);
  const wrapperRef = useRef(ref);

  const [defaultMeasure, setdefaultMeasure] = useState(true);
  const [newSizeGuide, setNewSuizeGuide] = useState(null);

  // Convert values
  // Combined two separate methods into single method based on properties
  const transformValues = useCallback(
    (table, measure) => {
      const newTable = table.map((row) => {
        // create empty array
        let newValues = [];
        // Check if row is convertable and add unit of length
        newValues.push(
          `${row.name} ${
            row.shouldConvert ? `(${measure === 'cm' ? 'cm' : 'inches'})` : ''
          }`,
        );
        // Loop through values and convert if convertable
        Object.values(row.values).map((u) => {
          if (!row.shouldConvert) return newValues.push(u.name);
          let rounded;
          if (measure === 'cm') {
            rounded = Math.round(Number(u.name) * 10) / 10;
          } else {
            let inch = u.name / 2.54;
            rounded = Math.round(inch * 10) / 10;
          }
          // push new value into new array
          return newValues.push(rounded);
        });
        return newValues;
      });
      // return flatten table
      return newTable;
    },
    [sizeGuide],
  );

  const onChangeRadio = useCallback(
    (e) => {
      const measure = e.target.value;

      const newSizeGuide = sizeGuide[0].lineItems
        ? sizeGuide.map((el) => ({
            ...el,
            lineItems: transformValues(el.lineItems, measure),
          }))
        : transformValues(sizeGuide, measure);

      if (measure === 'cm') {
        setNewSuizeGuide(newSizeGuide);
        setdefaultMeasure(true);
        radioGroupRef.current.children[0].children[0].classList.add(
          styles.active_label,
        );
        radioGroupRef.current.children[1].children[0].classList.remove(
          styles.active_label,
        );
      }
      if (measure === 'inches') {
        setNewSuizeGuide(newSizeGuide);
        setdefaultMeasure(false);
        radioGroupRef.current.children[1].children[0].classList.add(
          styles.active_label,
        );
        radioGroupRef.current.children[0].children[0].classList.remove(
          styles.active_label,
        );
      }
    },
    [sizeGuide, isMobile],
  );

  useEffect(() => {
    if (defaultMeasure) {
      let measure = 'cm';
      radioGroupRef.current.children[0].children[0].classList.add(
        styles.active_label,
      );
      radioGroupRef.current.children[1].children[0].classList.remove(
        styles.active_label,
      );

      const newSizeGuide = sizeGuide[0].lineItems
        ? sizeGuide.map((el) => ({
            ...el,
            lineItems: transformValues(el.lineItems, measure),
          }))
        : transformValues(sizeGuide, measure);

      setNewSuizeGuide(newSizeGuide);
    }
    if (!defaultMeasure) {
      let measure = 'inches';
      radioGroupRef.current.children[1].children[0].classList.add(
        styles.active_label,
      );
      radioGroupRef.current.children[0].children[0].classList.remove(
        styles.active_label,
      );

      const newSizeGuide = sizeGuide[0].lineItems
        ? sizeGuide.map((el) => ({
            ...el,
            lineItems: transformValues(el.lineItems, measure),
          }))
        : transformValues(sizeGuide, measure);

      setNewSuizeGuide(newSizeGuide);
    }
  }, [defaultMeasure, sizeGuide, isMobile]);

  return {
    radioGroupRef,
    wrapperRef,
    defaultMeasure,
    setdefaultMeasure,
    newSizeGuide,
    setNewSuizeGuide,
    transformValues,
    onChangeRadio,
  };
};
